import { mdiTrumpet } from "@mdi/js";
import {
  Action_DeleteDMGroupCategories,
  Action_DeleteDMGroupCategoriesSuccess,
  Action_DeleteDMGroupCategoriesFailed,
  Action_SaveDMGroupCategories,
  Action_SaveDMGroupCategoriesSuccess,
  Action_SaveDMGroupCategoriesFailed,
  Action_GetDMGroupCategories,
  Action_GetDMGroupCategoriesSuccess,
  Action_SaveThietLapGiaNhom,
  Action_SaveThietLapGiaNhomSuccess,
  Action_SaveThietLapGiaNhomFailed,
} from "actions/DanhMuc/DanhMucNhomSanPham/actionTypes";
import Config from "constants/configs";

const initialState = {

  isDataSelect: false,
  objData: {},
  objDataGroupCategories: {},
  objDataGroupCategoriesFull: {},
  isProgress: false,
  isSaveOk: false,
};
////////////////////////
const Reducer_SaveNhomSanPham = (state, action) => ({
  ...state,
  iSave: Config.sTrangThaiRequestAPI.DangGoi,
  isProgress: true,
  isSaveOk: false,
});
const Reducer_SaveNhomSanPhamSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    iSave: Config.sTrangThaiRequestAPI.Success,
    isProgress: false,
    isSaveOk: true,
  };
};
const Reducer_SaveNhomSanPhamFalse = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    iSave: Config.sTrangThaiRequestAPI.Failed,
    isProgress: false,
  };
};
////////////////////////
const Reducer_DeleteNhomSanPham = (state, action) => ({
  ...state,
  iDelete: Config.sTrangThaiRequestAPI.DangGoi,
  isProgress: true,
});
const Reducer_DeleteNhomSanPhamSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    iDelete: Config.sTrangThaiRequestAPI.Success,
    isProgress: false,
  };
};
const Reducer_DeleteNhomSanPhamFalse = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    iDelete: Config.sTrangThaiRequestAPI.Failed,
    isProgress: false,
  };
};
////////////////////////
const Reducer_GetDanhSachNhomSanPham = (state, action) => {
  if (action.payload.iPageIndex === -1) {
    initialState.isDataSelect = true;
    return {
      ...state,

    }
  } else {
    initialState.isDataSelect = false;
    return {
      ...state,
      isProgress: true,
    }
  }
};
const Reducer_GetDanhSachNhomSanPhamSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  if (initialState.isDataSelect) {
    return {
      ...state,
      objDataGroupCategoriesFull: action.payload,
    };
  } else {
    return {
      ...state,
      objDataGroupCategories: action.payload,
      isProgress: false,
    };
  }
};
/////////////////////////////////
const Reducer_SaveThietLApGiaNhom = (state, action) => ({
  ...state,
  isProgress: true,
});
const Reducer_SaveThietLApGiaNhomSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    isProgress: false,
  };
};
const Reducer_SaveThietLApGiaNhomFalse = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    isProgress: false,
  };
};

// end 
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case Action_DeleteDMGroupCategories:
      return Reducer_DeleteNhomSanPham(state, action);
    case Action_DeleteDMGroupCategoriesSuccess:
      return Reducer_DeleteNhomSanPhamSuccess(state, action);
    case Action_DeleteDMGroupCategoriesFailed:
      return Reducer_DeleteNhomSanPhamFalse(state, action);

    case Action_SaveDMGroupCategories:
      return Reducer_SaveNhomSanPham(state, action);
    case Action_SaveDMGroupCategoriesSuccess:
      return Reducer_SaveNhomSanPhamSuccess(state, action);
    case Action_SaveDMGroupCategoriesFailed:
      return Reducer_SaveNhomSanPhamFalse(state, action);

    case Action_GetDMGroupCategories:
      return Reducer_GetDanhSachNhomSanPham(state, action);
    case Action_GetDMGroupCategoriesSuccess:
      return Reducer_GetDanhSachNhomSanPhamSuccess(state, action);

    case Action_SaveThietLapGiaNhom:
      return Reducer_SaveThietLApGiaNhom(state, action);
    case Action_SaveThietLapGiaNhomSuccess:
      return Reducer_SaveThietLApGiaNhomSuccess(state, action);
    case Action_SaveThietLapGiaNhomFailed:
      return Reducer_SaveThietLApGiaNhomFalse(state, action);



    default:
      return state;
  }
};
export default authReducer;
